import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel Code
!function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  } else {
    b.head.appendChild(t);
  }
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
// @ts-ignore
window.fbq('init', '1272637858178142', {
  em: 'email@email.com',
  ph: '1234567890'
});
// @ts-ignore
window.fbq('track', 'PageView');
render(<App data-id="element-435" />, document.getElementById('root'));